import React, { useEffect, useRef, useState } from 'react';
import DropDownWrapper from './DropDownField.style';
import './style.scss';
import { CARET_DOWN_NEW_GREY_ICON, CARET_DOWN_NEW_ICON, CARET_UP_NEW_ICON } from '@Images';

type DropDownProps = {
  input?: {
    name: string;
    value: string;
  };
  autoComplete?: string;
  className?: string;
  label?: string;
  meta?: {
    error?: string;
    invalid?: boolean;
    valid?: boolean;
    touched?: boolean;
    form?: string;
  };
  placeholder?: string;
  tooltipDisplay?: boolean;
  type?: string;
  id?: string;
  iconStyles?: any;
  onIconClick?: () => any;
  disabled?: boolean;
  customStyle?: any;
  staticValues?: [
    {
      key: string;
      text: string;
      value: string;
    }
  ];
  handleChange?: any;
  isSearchable?: boolean;
  preselect_and_disable_if_one_item?: boolean;
  bindToThisObject?: string | undefined;
  dropDownStyle?: any;
  code?: boolean;
  isTouched: boolean;
};

const DropDownField: React.FC<DropDownProps> = (props: DropDownProps) => {
  const {
    staticValues,
    input,
    id,
    label,
    disabled,
    meta,
    handleChange,
    isSearchable,
    customStyle,
    iconStyles,
    preselect_and_disable_if_one_item,
    bindToThisObject,
    dropDownStyle,
    code,
    isTouched,
    className,
    type
  } = props;

  const inputRef = useRef<any>();
  const dropDownRef = useRef<any>();
  const inputWrapperRef = useRef<any>();
  const [selectedValue, setValue] = useState<string>('');
  const [placeholder, setPlaceholder] = useState<string>('');
  const [countryCode, setCountryCode] = useState<string | undefined>('');
  const [toggleDropDown, setToggleDropDown] = useState<boolean>(false);
  const [touched, setTouched] = useState<boolean>(isTouched);

  let ICON_ALT_UP = CARET_UP_NEW_ICON?.split('/').pop();
  ICON_ALT_UP = ICON_ALT_UP?.substr(0, ICON_ALT_UP?.indexOf('.'));
  let ICON_ALT_DOWN = CARET_UP_NEW_ICON?.split('/').pop();
  ICON_ALT_DOWN = ICON_ALT_DOWN?.substr(0, ICON_ALT_DOWN?.indexOf('.'));
  let ICON_ALT_DOWN_GREY = CARET_DOWN_NEW_GREY_ICON?.split('/').pop();
  ICON_ALT_DOWN_GREY = ICON_ALT_DOWN_GREY?.substr(0, ICON_ALT_DOWN_GREY?.indexOf('.'));

  const ID = input ? input.name : id;
  useEffect(() => {
    const value = staticValues?.find(
      (el) => el.key === bindToThisObject || el.value === bindToThisObject
    ) || {
      text: '',
      value: ''
    };
    setCountryCode(value?.value);
    const cropValue = code ? value?.text.split(' ')[0] : value?.text;
    setPlaceholder(cropValue);
    selectedValue && handleChange(meta?.form || '', input?.name || '', value.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue, bindToThisObject, staticValues]);
  useEffect(() => {
    setTouched(meta?.touched || false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta?.touched]);

  useEffect(() => {
    if (preselect_and_disable_if_one_item) {
      const value = (staticValues && staticValues[0].key) || bindToThisObject || '';
      const cropValue = code ? value.split(' ')[0] : value;
      setValue(cropValue);
      setPlaceholder('');

      handleChange(meta?.form || '', input?.name || '', value);
      inputRef.current.disabled = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staticValues, bindToThisObject]);

  useEffect(() => {
    function handleClickOutside(event: any) {
      const value = staticValues?.find(
        (el) => el.key === bindToThisObject || el.value === bindToThisObject
      ) || {
        text: placeholder,
        value: countryCode
      };
      const changingValueOnClick = () => {
        const cropValue = code ? value?.text.split(' ')[0] : value?.text;
        setValue(cropValue);
        value.value !== countryCode &&
          handleChange(meta?.form || '', input?.name || '', value.value);
        setToggleDropDown(false);
      };
      if (toggleDropDown) {
        if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
          if (event.target.id === `${ICON_ALT_UP}${ICON_ALT_DOWN}_id`) {
            return;
          }
          if (event.target.id === ID + '-input') {
            return setToggleDropDown(true);
          }
          changingValueOnClick();
        }
      } else {
        if (inputWrapperRef.current && !inputWrapperRef.current.contains(event.target)) {
          return changingValueOnClick();
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DROPDOWN_ID = input?.name + '-drop-down';

  const handleKeyDown = (e: any) => {
    const value = (selectedValue &&
      staticValues?.find((ele) =>
        ele.text.toLowerCase().includes(selectedValue.toLowerCase())
      )) || { value: '', text: '' };

    if (e.key === 'Enter') {
      if (value && value.value.length !== 0) {
        setValue('');
        setTouched(true);
        const cropValue = code ? value?.text.split(' ')[0] : value?.text;
        setPlaceholder(cropValue);
        handleChange(meta?.form || '', input?.name || '', value.value);
        setToggleDropDown(false);
        inputRef.current.focus();
      }
    }
    if (e.key === 'Tab') {
      let findValue = staticValues?.find((ele) => ele.text === placeholder) || {
        text: placeholder,
        value: countryCode
      };
      setTouched(true);
      setToggleDropDown(false);
      if (!findValue.value) {
        findValue = {
          text: (staticValues && staticValues[0].text) || placeholder,
          value: (staticValues && staticValues[0].value) || countryCode
        };
      }
      setValue(findValue.text);
      handleChange(meta?.form || '', input?.name || '', findValue?.value);
    }
  };

  type ELEMENT_PROPS = {
    key: string;
    text: string;
  };
  const dropDownTemplate = (element: ELEMENT_PROPS) => {
    return (
      <li
        onClick={
          staticValues && staticValues?.length > 1
            ? () => {
                const value = staticValues?.find((ele) => ele.key === element.key) || {
                  text: placeholder,
                  value: countryCode
                };
                const cropValue = code ? value?.text.split(' ')[0] : value?.text;
                setValue(cropValue);
                setPlaceholder(cropValue);
                handleChange(meta?.form || '', input?.name || '', value.value);
                setToggleDropDown(false);
                inputRef.current.focus();
                setTouched(true);
              }
            : undefined
        }
        className={element.text === placeholder ? 'change-bg-clr' : ''}
        id={element.key}
        key={element.key}
      >
        {element.text}
      </li>
    );
  };

  let noValuesFound = 0;

  return (
    <DropDownWrapper
      $valueExist={(bindToThisObject && bindToThisObject.length !== 0) || selectedValue !== ''}
      disabled={disabled}
      $invalid={touched && meta?.invalid && !placeholder}
      $dropDownHeight={staticValues?.length}
      $delayTransaction={placeholder === '' && !toggleDropDown}
      style={{ ...customStyle }}
      id={ID}
      ref={inputWrapperRef}
      $inputResponcive={code ? placeholder.length : 0}
    >
      <div id={ID + '-wrapper'} className="drop-down-input">
        <label htmlFor={ID + '-input'}>{label}</label>
        <input
          {...props.input}
          type={type}
          className={className}
          ref={inputRef}
          value={selectedValue}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={() => {
            setValue('');
          }}
          onClick={() => {
            setValue('');
            setToggleDropDown(true);
          }}
          onChange={(e) => {
            if (isSearchable) {
              setValue(e.target.value);
              setToggleDropDown(true);
            }
          }}
          onBlur={(e) => {
            e.preventDefault();
            setTouched(true);
          }}
          onKeyDown={isSearchable ? handleKeyDown : undefined}
          id={ID + '-input'}
          autoComplete="off" // disabling autocomplete due to issues with few old version browsers NINSTA-16031
        />
        {disabled ? (
          <img
            id={`${ICON_ALT_DOWN_GREY}_id`}
            src={CARET_DOWN_NEW_GREY_ICON}
            style={{ ...iconStyles }}
            alt={ICON_ALT_DOWN_GREY}
          />
        ) : (
          <img
            id={`${ICON_ALT_UP}${ICON_ALT_DOWN}_id`}
            onClick={() => {
              setToggleDropDown(!toggleDropDown);
              inputRef.current.focus();
            }}
            style={{ ...iconStyles }}
            src={toggleDropDown ? CARET_UP_NEW_ICON : CARET_DOWN_NEW_ICON}
            alt={toggleDropDown ? ICON_ALT_UP : ICON_ALT_DOWN}
          />
        )}
      </div>
      {meta?.error && touched && !placeholder && (
        <p style={{ top: code ? '57%' : '95%' }}>{meta.error}</p>
      )}
      {toggleDropDown && (
        <ul
          ref={dropDownRef}
          className="drop-down-value"
          style={{ ...dropDownStyle }}
          id={DROPDOWN_ID}
        >
          {staticValues?.map((el) => {
            if (
              selectedValue !== '' &&
              (el.text.toLowerCase().includes(selectedValue.toLowerCase()) ||
                (code && el.text.toLowerCase().indexOf(selectedValue.toLowerCase()) > -1))
            ) {
              return dropDownTemplate(el);
            } else if (
              (!el.text.toLowerCase().includes(selectedValue.toLowerCase()) ||
                (code && el.text.toLowerCase().indexOf(selectedValue.toLowerCase()) === -1)) &&
              staticValues.length - 1 === noValuesFound
            ) {
              return <li key="no-results-found">no results found</li>;
            } else if (selectedValue === '') {
              return dropDownTemplate(el);
            } else {
              noValuesFound++;
              return null;
            }
          })}
        </ul>
      )}
    </DropDownWrapper>
  );
};

export default DropDownField;
